import {Box, Paper, Typography, useTheme} from "@mui/material";

// Champions, Loyal, At Risk
// Potential Loyalists, Need Attention, Hibernating
// New Customers, Promising, Lost
const GRID = [
    [
        {segment: 'Champions', key: 'r0c0', color: '#2E7D32', fg: '#fff'},
        {segment: 'Loyal', key: 'r0c1', color: '#8BC34A', fg: '#1b5e20'},
        {segment: 'At Risk', key: 'r0c2', color: '#F44336', fg: '#fff'}
    ],
    [
        {segment: 'Potential Loyalists', key: 'r1c0', color: 'rgb(187, 214, 238)', fg: '#0d47a1'},
        {segment: 'Need Attention', key: 'r1c1', color: 'rgb(255, 192, 0)', fg: '#37474F'},
        {segment: 'Hibernating', key: 'r1c2', color: '#FFEB3B', fg: '#795548'}
    ],
    [
        {segment: 'New Customers', key: 'r2c0', color: 'rgb(68, 114, 196)', fg: '#fff'},
        {segment: 'Promising', key: 'r2c1', color: 'rgb(236, 239, 241)', fg: '#263238'},
        {segment: 'Lost', key: 'r2c2', color: '#9E9E9E', fg: '#fff'}
    ]
];

export const RfmSegmentGrid = ({
    segmentCounts,
    selectedSegment = null,
    onSelectSegment,
    compact = false,
    omitOuterPaper = false,
    interactive = true,
    matrixWidth = null,
    cardHeight = null
}) => {
    const theme = useTheme();
    const cellPad = compact ? 8 : 10;
    const labelVariant = 'body2';
    const countVariant = 'h6';
    const labelSx = compact ? {fontWeight: 600, lineHeight: 1.15, fontSize: '0.8125rem'} : {fontWeight: 600, lineHeight: 1.15};
    const countSx = compact ? {fontWeight: 700, fontSize: '1.1rem'} : {fontWeight: 700};
    const axisFont = compact ? 12 : 11;
    const gap = compact ? 6 : 8;

    const totalAccounts = Object.values(segmentCounts || {}).reduce(
        (sum, count) => sum + (Number(count) || 0),
        0
    );

    const noop = () => {};
    const handleSelect = onSelectSegment || noop;

    const renderCell = (cell) => {
        const count = segmentCounts?.[cell.segment] || 0;
        const selected = interactive && selectedSegment === cell.segment;
        return (
            <div
                key={cell.key}
                onClick={interactive ? () => handleSelect(selected ? null : cell.segment) : undefined}
                style={{
                    background: cell.color,
                    color: cell.fg,
                    padding: cellPad,
                    borderRadius: 6,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    cursor: interactive ? 'pointer' : 'default',
                    border: selected ? `3px solid ${theme.palette.primary.main}` : '3px solid transparent',
                    boxShadow: selected ? '0 0 0 2px #fff inset' : 'none',
                    transition: interactive ? 'border-color 0.15s ease' : undefined,
                    width: '100%',
                    aspectRatio: '1 / 1',
                    height: 'auto',
                    boxSizing: 'border-box',
                    minHeight: 0
                }}
            >
                <Typography variant={labelVariant} sx={labelSx}>
                    {cell.segment}
                </Typography>
                <Typography variant={countVariant} sx={countSx}>
                    {count}
                </Typography>
            </div>
        );
    };

    const gridInner = (
        <div style={{display: 'flex', width: '100%'}}>
            <div style={{
                writingMode: 'vertical-rl',
                transform: 'rotate(180deg)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: axisFont, color: '#666', marginRight: compact ? 4 : 8,
                flexShrink: 0
            }}>
                Frequency (low → high)
            </div>
            <div style={{flex: 1, minWidth: 0, width: 0}}>
                <div style={{display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap}}>
                    {GRID.flat().map(renderCell)}
                </div>
                <div style={{textAlign: 'center', fontSize: axisFont, color: '#666', marginTop: compact ? 4 : 6}}>
                    Recency (high → low)
                </div>
            </div>
        </div>
    );

    const gridBlock = matrixWidth != null ? (
        <Box sx={{width: matrixWidth, maxWidth: '100%', mx: 'auto'}}>
            {gridInner}
        </Box>
    ) : gridInner;

    if (omitOuterPaper) {
        return gridBlock;
    }

    const paperSx = {
        ...theme.palette.contentPanel,
        padding: compact ? 2 : 3,
        borderRadius: 2,
        ...(cardHeight != null
            ? {
                height: cardHeight,
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                boxSizing: 'border-box'
            }
            : {})
    };

    return (
        <Paper sx={paperSx}>
            <Typography variant="subtitle1" style={{fontWeight: 600, marginBottom: 2}}>
                RFM Segments
            </Typography>
            <Typography
                variant="body2"
                color="textSecondary"
                style={{marginBottom: compact ? 8 : 12}}
            >
                {totalAccounts.toLocaleString()} account{totalAccounts === 1 ? '' : 's'}
            </Typography>
            {cardHeight != null ? (
                <Box sx={{flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', minHeight: 0}}>
                    {gridBlock}
                </Box>
            ) : (
                gridBlock
            )}
        </Paper>
    );
};
